import {
  Alert,
  Box,
  Drawer as MUIDrawer,
  styled,
  Typography,
  TypographyProps,
} from '@mui/material';

import { Drawer } from '@/components/Layout/Drawer/Drawer';

import { getAssetPath } from '@/constants/configs';

export const DrawerContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  flex: 1,
  minHeight: 0,
  width: '100%',

  [theme.breakpoints.up('lg')]: {
    justifyContent: 'flex-start',
    paddingTop: theme.spacing(6),
  },
}));

export const StyledDocumentsSigningDrawer = styled(Drawer)(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    '.DrawerContent': {
      paddingTop: 0,
    },
  },
}));

export const StyledApprovedDrawer = styled(MUIDrawer)(({ theme }) => ({
  '.MuiDrawer-paper': {
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
  },

  [theme.breakpoints.up('lg')]: {
    '.MuiDrawer-paper': {
      borderRadius: 0,
      height: '100%',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
}));

export const ApprovedDrawerContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(4),
  maxWidth: 464,
  width: '100%',

  '.MuiButton-root': {
    display: 'block',
    maxWidth: 360,
    margin: `0 auto`,
  },
}));

export const ApprovedImg = styled(props => (
  <img src={getAssetPath('/approved.png')} {...props} />
))(({ theme }) => ({
  display: 'block',
  margin: `0 auto ${theme.spacing(5)}`,
  width: 232,
}));

export const StyledRequiredDocumentSelectDrawer = styled(Drawer)(
  ({ theme }) => ({
    '.DrawerContent': {
      minHeight: 'unset',
      paddingTop: theme.spacing(10),
      justifyContent: 'flex-end',
      paddingBottom: theme.spacing(6),
    },

    [theme.breakpoints.up('lg')]: {
      '.DrawerContent': {
        justifyContent: 'flex-start',
      },
    },
  }),
);

export const StyledAlertBackSide = styled(Alert)(({ theme }) => ({
  width: '100%',
  border: `1px solid ${theme.palette.green[500]}`,
  marginBottom: theme.spacing(4),
}));

export const DrawerLoader = styled(Box)(({ theme }) => ({
  flex: 1,
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  paddingBottom: theme.spacing(4),
}));

export const VerificationLabel = styled(Box)({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
});

export const HighlightTitle = styled((props: TypographyProps) => (
  <Typography variant="h3" component="span" {...props} />
))<TypographyProps>(({ theme }) => ({
  color: theme.palette.primaries[500],
}));

export const IdentityCheckReviewContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: 0,
  width: '100%',
  padding: theme.spacing(2),
  paddingBottom: theme.spacing(3),
}));

export const IdentityCheckReviewScroll = styled(Box)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  width: '100%',
  '& .MuiAccordion-root': {
    '&:before': { display: 'none' },
    border: 'none',
    boxShadow: 'none',
    outline: 'none',
    '&::before': { display: 'none' },
  },
  '& .MuiAccordionSummary-root': {
    borderBottom: 'none',
    paddingBottom: theme.spacing(1),
    '&.Mui-expanded': {
      borderBottom: 'none',
      minHeight: 0,
    },
  },
  '& .MuiAccordionDetails-root': {
    paddingTop: 0,
    paddingBottom: theme.spacing(2),
    border: 'none',
  },
}));

export const IdentityCheckReviewActions = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  width: '100%',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));
